import script from "./LocalePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./LocalePanel.vue?vue&type=script&setup=true&lang=js"

import "./LocalePanel.vue?vue&type=style&index=0&id=88411c98&lang=css"

const __exports__ = script;

export default __exports__